<template>
    <div
        class="container px-0 sticker-gallery--content"
        v-if="photos && photos.length > 0"
    >
        <div class="row sticker-gallery--content-photos">
            <div
                class="sticker-gallery--content-photos-frame"
                v-for="(photo, index) in photos"
            >
                <div
                    class="sticker-gallery--content-photos-frame-photo"
                    v-on:click="selectPhoto(index)"
                    v-bind:style="{
                        background: 'url(\'' + (photo.url || photo.full_url || photo) + '\')',
                    }"
                ></div>

                <span class="sticker-gallery--content-photos-title">{{humanise(photo.name)}}</span>
                <span class="sticker-gallery--content-photos-description">{{humanise(photo.description)}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StickerViewComponent',
    props: {
        photos: {
            type: Array,
            default: [],
        },
    },
    methods: {
        humanise(name) {
            name = name.replace(/_+/g, ' ');

            name = name.replace(/\b\w/g, function (char) {
                return char.toUpperCase();
            });

            return name;
        },
    },
};
</script>
